(function() {
  'use strict';

  function initAccordions(root) {
    root = root || document;
    var items = root.querySelectorAll('.faq-item');
    items.forEach(function(item) {
      var btn = item.querySelector('.faq-item__question');
      var answer = item.querySelector('.faq-item__answer');
      if (!btn || !answer) return;
      btn.addEventListener('click', function() {
        var isOpen = item.classList.contains('is-open');
        // Close siblings in same list
        var list = item.closest('.faq-accordion__list');
        if (list) {
          list.querySelectorAll('.faq-item.is-open').forEach(function(sibling) {
            sibling.classList.remove('is-open');
            sibling.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
            sibling.querySelector('.faq-item__answer').hidden = true;
          });
        }
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAccordions(document);
  });

  document.addEventListener('shopify:section:load', function(e) {
    initAccordions(e.target);
  });
})();
